import { Label, TextInputLarge } from '../../../../components/forms/input';
import { FieldValues, useForm } from 'react-hook-form';
import { usePostMutation, usePutMutation } from '../../../../hooks/use-mutations';
import { MapLayer, Metadata as MetadataType } from '../../types/map-layer';
import { useParams } from 'react-router';
import { useEffect } from 'react';
import { useQuery } from '../../../../hooks/use-query';

export const Metadata = (): JSX.Element => {
  const params = useParams();
  const layerId = params.id as string;
  const { register, handleSubmit, setValue } = useForm();
  const postMutation = usePostMutation<MapLayer>({ path: '/map-layers/metadata' });
  const metadata = useQuery<MetadataType>({ path: `/map-layers/${layerId}/metadata`, options: { enabled: layerId !== 'new' } });
  const putMutation = usePutMutation<MapLayer>({ path: `/map-layers/metadata/${metadata.data?.id as string}` });

  const onSubmit = (data: FieldValues): void => {
    !metadata.data?.id ? postMutation.mutate({ ...data, layerId }) : putMutation.mutate(data);
  };

  useEffect(() => {
    if (metadata.data?.id) {
      setExistingValues();
    }
  }, [metadata.data]);

  const setExistingValues = (): void => {
    for (const key in metadata.data) {
      setValue(key, metadata.data[key as keyof MetadataType]);
    }
  };

  return <form id="current-form" onSubmit={handleSubmit(onSubmit)}>
    <div className="mb-4">
      <Label name="name">Title</Label>
      <TextInputLarge {...register('title')} placeholder="Title" />
    </div>
    <div className="mb-4">
      <Label name="name">Location</Label>
      <TextInputLarge {...register('location')} placeholder="Location" />
    </div>
    <div className="mb-4">
      <Label name="name">Abstract</Label>
      <TextInputLarge {...register('abstractText')} placeholder="Abstract" />
    </div>
    <div className="mb-4">
      <Label name="name">Updated </Label>
      <TextInputLarge {...register('publishDate')} placeholder="Updated" />
    </div>
    <div className="mb-4">
      <Label name="name">Origins</Label>
      <TextInputLarge {...register('origin')} placeholder="Origins" />
    </div>
    <div className="mb-4">
      <Label name="name">View Full Metadata</Label>
      <TextInputLarge {...register('link')} />
    </div>
  </form>;
};
